"use client";

import { Card } from "@/components/ui/card";
import { motion } from "framer-motion";

export function ProblemSolutionSection() {
  return (
    <section className="py-20 md:py-32 bg-muted/50 dark:bg-background">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-5xl font-bold mb-4 text-foreground">
            Stop Losing Customers to{" "}
            <span className="text-primary">Big Box Contractors</span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Your plaster and microcement business offers expert craftsmanship
            and personalized service, but homeowners can&apos;t find you. We
            solve that problem.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {/* Problem Card */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2, duration: 0.6 }}
          >
            <Card className="p-8 h-full bg-card dark:bg-muted border border-destructive/40 dark:border-destructive/30 shadow">
              <h3 className="text-2xl font-bold mb-6 text-foreground">
                The Problem:
              </h3>
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <span className="text-2xl shrink-0">❌</span>
                  <span className="text-muted-foreground">
                    Homeowners hire inexperienced contractors from big platforms
                    instead of specialized plaster artisans
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-2xl shrink-0">❌</span>
                  <span className="text-muted-foreground">
                    No centralized directory for plaster, microcement, and
                    Venetian plaster specialists exists
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-2xl shrink-0">❌</span>
                  <span className="text-muted-foreground">
                    Your expert craftsmanship is invisible to design-conscious
                    homeowners searching online
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-2xl shrink-0">❌</span>
                  <span className="text-muted-foreground">
                    You rely on word-of-mouth and Instagram instead of
                    systematic lead generation
                  </span>
                </li>
              </ul>
            </Card>
          </motion.div>

          {/* Solution Card */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4, duration: 0.6 }}
          >
            <Card className="p-8 h-full bg-card dark:bg-muted border border-green-400/40 dark:border-green-500/30 shadow">
              <h3 className="text-2xl font-bold mb-6 text-foreground">
                Our Solution:
              </h3>
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <span className="text-2xl shrink-0">✅</span>
                  <span className="text-muted-foreground">
                    America&apos;s ONLY comprehensive plaster and microcement
                    applicator directory
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-2xl shrink-0">✅</span>
                  <span className="text-muted-foreground">
                    Customers find you when searching &quot;plaster applicators
                    near me&quot; or &quot;microcement installers&quot;
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-2xl shrink-0">✅</span>
                  <span className="text-muted-foreground">
                    Pre-qualified homeowners ready to invest in premium finishes
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-2xl shrink-0">✅</span>
                  <span className="text-muted-foreground">
                    Featured listings get 5x more visibility and phone calls
                  </span>
                </li>
              </ul>
            </Card>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
